<template>
  <div class="mycontainer">
    <el-form>
      <el-tabs :model="activeName">
        <el-tab-pane
          :label="item.versionStr"
          :name="index + ''"
          v-for="(item, index) in baseInfo"
          :key="index + ''"
        >
          <div class="card">
            <el-descriptions title="基本信息" :column="4" size="medium" border>
              <el-descriptions-item label="课题编号">{{
                item.courseId
              }}</el-descriptions-item>
              <el-descriptions-item label="课题名称" span="2">{{
                item.courseName
              }}</el-descriptions-item>
              <el-descriptions-item
                v-if="item.courseGroup == 3"
                label="项目类型："
                >{{ item.courseProjectStr }}</el-descriptions-item
              >
              <el-descriptions-item label="课题归属部门">{{
                item.bmmc
              }}</el-descriptions-item>
              <el-descriptions-item label="课题负责人">{{
                item.courseLeaderName
              }}</el-descriptions-item>
              <el-descriptions-item label="专业职称">{{
                item.professional
              }}</el-descriptions-item>
              <el-descriptions-item label="工作单位">{{
                item.workPlace
              }}</el-descriptions-item>
              <el-descriptions-item label="E-mail">{{
                item.email
              }}</el-descriptions-item>
              <el-descriptions-item label="最终成果形式" span="2">{{
                item.finalAchievementFormStr
              }}</el-descriptions-item>
              <el-descriptions-item label="课题类型" span="2">{{
                item.courseTypeStr
              }}</el-descriptions-item>
              <el-descriptions-item label="研究专长" span="2">{{
                item.studySpeciality
              }}</el-descriptions-item>
              <el-descriptions-item label="备注" span="2">{{
                item.remark
              }}</el-descriptions-item>
            </el-descriptions>
            <!-- <el-row>
              <el-col :span="24" class="label">基本信息</el-col>
            </el-row>
            <div class="card_content">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="课题编号：">{{ item.courseId }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="课题名称：">{{ item.courseName }}</el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="item.courseGroup == 3">
                <el-col :span="24">
                  <el-form-item label="项目类型：">
                    {{ item.courseProjectStr }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="课题归属部门：">{{ item.bmmc }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="课题负责人：">{{ item.courseLeaderName }}</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="专业职称：">{{ item.professional }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="工作单位：">{{ item.workPlace }}</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="E-mail：">{{ item.email }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="最终成果形式：">{{ item.finalAchievementFormStr }}</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="课题类型：">{{ item.courseTypeStr }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="研究专长：">{{ item.studySpeciality }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="备注：">{{ item.remark }}</el-form-item>
                </el-col>
            </el-row>-->
            <!-- </div> -->
          </div>
          <div class="card">
            <el-row>
              <el-col :span="24" class="label">
                <span>主要成员</span>
              </el-col>
            </el-row>
            <el-table
              :max-height="height"
              :data="cyList"
              fit
              highlight-current-row
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
            >
              <el-table-column
                label="姓名"
                align="left"
                prop="memberName"
                min-width="80px"
                :show-overflow-tooltip="true"
              />

              <el-table-column
                label="性别"
                align="left"
                prop="sex"
                min-width="80px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="出生日期"
                align="left"
                prop="birthday"
                min-width="150px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="职称职务"
                align="left"
                prop="post"
                min-width="120px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="工作单位"
                align="left"
                prop="workPlace"
                min-width="80px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="联系电话"
                align="left"
                prop="phone"
                min-width="120px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="课题承担任务"
                align="left"
                prop="courseMission"
                min-width="150px"
                :show-overflow-tooltip="true"
              />
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
            <pagination
              v-show="cyCount > 0"
              :total="cyCount"
              :page.sync="cylistQuery.page"
              :limit="cylistQuery.pageSize"
              @pagination="getCyList"
            />
          </div>
          <div
            class="card card3"
            v-show="item.metaPropList && item.metaPropList.length > 0"
          >
            <el-row>
              <el-col :span="24" class="label">研究方案</el-col>
            </el-row>
            <el-row>
              <el-col
                :span="24"
                v-for="(item2, index2) in item.metaPropList"
                :key="index2"
              >
                <div class="content">
                  <div v-if="item2.type == 1">
                    <div class="content_title">{{ item2.cname }}</div>
                    <div class="content_text" v-html="item2.propValue"></div>
                  </div>
                  <div v-else>
                    <div class="content_title">{{ item2.cname }}</div>
                    <div
                      :id="`wangEditor_lxsq_result_${index}_${index2}`"
                    ></div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import wangEditor from "wangeditor";
import LxsqForm from "../courseLxsqForm/lxsqForm.vue";
import { getItemApplyList, getListCourseMember } from "@/api/course.js";
import Pagination from "@/components/Pagination";

export default {
  components: { Pagination, LxsqForm },
  props: ["mxParams"],
  data() {
    return {
      addDialog: false,
      editDialog: false,
      baseInfo: [],
      height: 500,
      cyList: [],
      cyCount: 0,
      cylistQuery: {
        page: 1,
        pageSize: 10,
      },
      editor: null,
      activeName: "0",
      editorDataList: [],
      editorList: [],
    };
  },
  computed: {
    ...mapGetters(["task"]),
  },
  created() {
    if (!this.mxParams) {
      this.mxParams = this.$route.query;
    }
    getItemApplyList({ courseId: this.mxParams.id }).then((res) => {
      if (res.code == 0) {
        this.baseInfo = res.data;
      }
    });
    this.getCyList();
  },
  mounted() {
    const timer = setInterval(() => {
      if (this.baseInfo && this.baseInfo.length > 0) {
        for (let i = 0; i < this.baseInfo.length; i++) {
          // for (let i in this.baseInfo) {

          for (let j = 0; j < this.baseInfo[i].metaPropList.length; j++) {
            // for (let j in this.baseInfo[i].metaPropList) {
            if (this.baseInfo[i].metaPropList[j].type == 2) {
              let editor = new wangEditor(`#wangEditor_lxsq_result_${i}_${j}`);
              editor = this.editorConfig(editor);
              editor.txt.html(this.baseInfo[i].metaPropList[j].propValue);
              // editor.disable();
              this.editorList.push(editor);
              document.querySelector(
                `#wangEditor_lxsq_result_${i}_${j} .w-e-toolbar`
              ).style.backgroundColor = "#f3f3f3";
              document.querySelector(
                `#wangEditor_lxsq_result_${i}_${j} .w-e-text-container`
              ).style.backgroundColor = "#f3f3f3";
            }
          }
        }
        clearInterval(timer);
      }
    }, 50);
  },
  methods: {
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中
      // editor.config.onchange = function() {
      //   if (editor.txt.html() == "") {
      //     editor.txt.html("&nbsp");
      //   }
      // };

      editor.create();
      return editor;
    },
    getCyList() {
      getListCourseMember({
        applyId: this.mxParams.aid,
        ...this.cylistQuery,
      }).then((res2) => {
        if (res2.code == 0) {
          this.cyList = res2.data;
          this.cyCount = res2.count;
        }
      });
    },
    getSon(temp) {
      this.addDialog = false;
      this.editDialog = false;
    },
  },
};
</script>
<style lang="less" scoped>
.card {
  //   border-bottom: 2px solid #f3f3f3;
  .label {
    font-size: 16px;
    font-weight: bold;
    height: 44px;
    line-height: 44px;
    padding-left: 15px;
  }
  .card_content {
    padding: 0 10%;
  }
}
.card3 {
  .card3_label {
    margin-left: 30px;
    height: 44px;
    line-height: 44px;
    font-weight: bold;
    font-size: 15px;
  }
}
.card:nth-of-type(1) {
  margin-top: 0;
}
.content {
  margin-bottom: 30px;
  line-height: 40px;
  .content_title {
    font-weight: 700;
    margin-bottom: 15px;
  }
  .content_text {
    background-color: #f3f3f3;
    padding: 5px 15px;
    margin-right: 15px;
  }
}
</style>
